// schema
import * as ISchema from "@schema";

import { requestSubscription } from "react-relay";
import { Environment } from "relay-runtime";
import { subscription } from "./UpdateOrgFlowState.gql";
import { logger } from "@util/logger.util";

export function updateOrgFlowStateSubscription(
  environment: Environment,
  input: ISchema.IUpdateFlowStateSubscriptionInput,
) {
  const variables = {
    input,
  };

  return requestSubscription(environment, {
    subscription,
    variables,
    // optional but recommended:
    onCompleted: () => logger.debug("Subscription request for OrgFlowState completed"),
    onError: (error) => logger.error("Subscription request for OrgFlowState failed", error),
  });
}
